export const couponConf = {
    "jdxc": {
        name: "精典洗车服务",
        title: "四川航空金熊猫里程兑换精典洗车服务",
        login: 'scal',
        banner: require("@/assets/images/jingdian/banner.png"),
        logo: "",
        miniLogo: require("@/assets/images/jingdian/mini_logo.png"),
        coupon: require("@/assets/images/jingdian/coupon.png"),
        type: "jd-scal",
        storeLst: require("@/utils/module/jdxc-stores.json"),
        storeName: "金熊猫会员可用门店列表",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/jingdian/bgcolor.png"),
        auto_coupon: false,
        desc: [
            {
                title: "",
                content: [
                    "卡券有效期:自兑换之日起90日内有效，请在有效期内到店使用，过期作废，不退不补；",
                    "使用规则:此券为一次性使用，一经兑换，不可退换、转售、兑现、找零、拆分使用，里程兑换卡券不提供报销凭证；",
                    "如需帮助，请拨打服务热线：4000-360-195。"
                ]
            },
            {
                title: "使用说明",
                content: [
                    "适用门店及联系方式：四川区域“四川精典汽车”连锁门店，详情及咨询电话请<a style='color: #2A48A8;font-weight: 600' href='store'>点击查看</a>；",
                    "兑换使用：兑换成功后系统将发送消费短信至川航金熊猫会员绑定手机号，<span style='color: #2A48A8;font-weight: 600'>消费短信为到店核销唯一凭证</span>，请妥善保存，到店消费时请出示短信内“付款码”即可使用；",
                    "注意事项：周一至周日门店营业时间内均可使用，如遇高峰时段可能需要排队；（为了节约您的时间，您也可以提前致电门店询问排队情况）",
                    "本券使用时不与店内其他活动同享，到店使用须知及其他注意事项请以具体商品兑换页展示内容为准。"
                ]
            }
        ],
        style: {
            "--theme-color": "#DAE2ED",
            "--theme-copyright-color": "#3970C3",
            "--theme-text-color": "#5282C9",
            "--theme-toolbar-card-color": "#5787CB",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#2C5FC6",
            "--btn-color": "#477FEB"
        }
    },
    "sqwl": {
        name: "川渝文旅一卡通",
        title: "四川航空金熊猫里程兑换川渝文旅一卡通",
        banner: require("@/assets/images/sqwl/banner.png"),
        login: 'scal',
        logo: "",
        // miniLogo: require("@/assets/images/jingdian/mini_logo.png"),
        coupon: require("@/assets/images/sqwl/coupon.png"),
        auto_coupon: true,
        type: "sqwl",
        storeLst: require("@/utils/module/jdxc-stores.json"),
        storeName: "金熊猫会员可用门店列表",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/sqwl/bgcolor.png"),
        desc: [
            {
                title: "",
                content: [
                    // "有效期:年卡自购买之日起<span style='color:#BA274B'>60天内须激活开通</span>，自激活开通之日起365天内有效;60天内未激活开通年卡(绑定身份信息)，系统将自动开始计算有效期；",
                    "有效期：年卡自兑换之日起<span style='color:#BA274B'>60天内需激活并绑定身份证信息，自激活之日起365天内有效</span>；兑换成功后60天内未激活且未绑定身份证信息，则系统将自动开始计算有效期（例：兑换成功后，第61天激活并绑定身份证信息，则有效期为364天）",
                    "适用对象：拥有18位身份证号码的旅客；",
                    "发放方式：兑换成功后，将以短信的形式发放激活码至兑换时填写的手机号，请确认手机号填写正确，因手机号填写错误造成的损失由会员本人承担；",
                    "查收激活码：<span style='color:#BA274B'>兑换成功后，您预留的手机号将收到一条包含“激活码”的短信，请妥善保存</span>;",
                    "里程兑换权益不提供报销凭证，兑换成功不可退/换、转售、兑现、找零或拆分使用；",
                    "如需帮助，请拨打服务热线：4000-360-195。"
                ]
            }
        ],
        style: {
            "--theme-color": "#FFE3EA",
            "--theme-copyright-color": "#BA274B",
            "--theme-text-color": "#BB2A4E",
            "--theme-toolbar-card-color": "#D43030",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#2C5FC6",
            "--btn-color": "#477FEB"
        }
    },
    "meland-xmair": {
        name: "MELAND",
        title: "白鹭积分兑换MELAND亲子游玩",
        banner: require("@/assets/images/meland/banner2.png"),
        logo: "",
        show_plug: true,
        miniLogo: require("@/assets/images/meland/logo.png"),
        // miniLogo: require("@/assets/images/jingdian/mini_logo.png"),
        coupon: require("@/assets/images/sqwl/coupon.png"),
        auto_coupon: true,
        type: "meland",
        login: "xm_air",
        storeLst: require("@/utils/module/jdxc-stores.json"),
        storeName: "",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/meland/order.png"),
        headerImg: require("@/assets/images/meland/title.png"),
        desc: [
            {
                title: "",
                content: [
                    // "有效期:年卡自购买之日起<span style='color:#BA274B'>60天内须激活开通</span>，自激活开通之日起365天内有效;60天内未激活开通年卡(绑定身份信息)，系统将自动开始计算有效期；",
                    "积分兑换产品不提供报销凭证，一经兑换，不可退换、转售、兑现、找零、拆分使用，可转赠给他人使用；",
                    "本产品为卡密产品，兑换时请填写正确的收货手机号，因手机号填写错误造成的损失由会员本人承担；",
                    "如遇产品不能正常兑换或使用，请拨打服务热线：4000-360-195。"
                ]
            }
        ],
        style: {
            "--theme-color": "#F1E6CF",
            "--theme-copyright-color": "#000",
            "--theme-text-color": "#A7823A",
            "--theme-logo-bg-color": "#A7823A",
            "--theme-toolbar-card-color": "#2A83E5",
            "--theme-copy-color": "#2A83E5",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#2C5FC6",
            "--btn-color": "#477FEB"
        }
    },
    "meland-scal": {
        name: "MELAND",
        title: "里程兑换MELAND亲子游玩",
        banner: require("@/assets/images/meland/banner.png"),
        logo: "",
        miniLogo: require("@/assets/images/meland/logo.png"),
        // miniLogo: require("@/assets/images/jingdian/mini_logo.png"),
        coupon: require("@/assets/images/sqwl/coupon.png"),
        auto_coupon: true,
        type: "meland-scal",
        login: "scal",
        storeLst: require("@/utils/module/jdxc-stores.json"),
        storeName: "",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/meland/order.png"),
        headerImg: require("@/assets/images/meland/title1.png"),
        desc: [
            {
                title: "",
                content: [
                    // "有效期:年卡自购买之日起<span style='color:#BA274B'>60天内须激活开通</span>，自激活开通之日起365天内有效;60天内未激活开通年卡(绑定身份信息)，系统将自动开始计算有效期；",
                    "里程兑换产品不提供报销凭证，一经兑换，里程不可退；",
                    "本产品兑换成功后，兑换码将以短信的形式发送到兑换时填写的收货手机号，因手机号填写错误造成的损失由会员本人承担；",
                    "兑换成功后，请在30天内前往“MELAND”小程序“兑换中心”输入兑换码激活使用；产品激活后请在对应有效期内使用，过期不补不退；",
                    "本券为一次性使用券，不可退/换、转售、兑现、找零、拆分使用，可转赠他人使用；",
                    "如遇产品不能正常兑换或使用，请拨打服务热线：4000-360-195；",
                    "本平台仅是提供会员与商户之间的兑换服务平台，如遇商品质量问题，请及时与商户联系。"
                ]
            }
        ],
        style: {
            "--theme-color": "#F1E6CF",
            "--theme-copyright-color": "#000",
            "--theme-text-color": "#A7823A",
            "--theme-logo-bg-color": "#A7823A",
            "--theme-toolbar-card-color": "#D43030",
            "--theme-copy-color": "#D43030",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#D43030",
            "--btn-color": "#D43030"
        }
    },
    "hbwl-xmair": {
        name: "河北文旅一卡通",
        title: "白鹭积分兑换河北文旅一卡通",
        banner: "https://images.jifen360.com/hbwl/banner.png",
        login: 'xm_air',
        logo: "",
        show_plug:true,
        // miniLogo: require("@/assets/images/jingdian/mini_logo.png"),
        coupon: require("@/assets/images/hbwl/coupon.png"),
        auto_coupon: true,
        type: "hbwl",
        storeLst: require("@/utils/module/jdxc-stores.json"),
        storeName: "金熊猫会员可用门店列表",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/hbwl/order-bg.png"),
        desc: [
            {
                title: "",
                content: [
                    // "有效期:年卡自购买之日起<span style='color:#BA274B'>60天内须激活开通</span>，自激活开通之日起365天内有效;60天内未激活开通年卡(绑定身份信息)，系统将自动开始计算有效期；",
                    "有效期：年卡自兑换之日起<span style='color:#BA274B'>60天内需激活并绑定身份证信息，自激活之日起365天内有效</span>；兑换成功后60天内未激活且未绑定身份证信息，则系统将自动开始计算有效期（例：兑换成功后，第61天激活并绑定身份证信息，则有效期为364天）",
                    "适用对象：拥有18位身份证号码的旅客；",
                    "发放方式：兑换成功后，将以短信的形式发放激活码至兑换时填写的手机号，请确认手机号填写正确，因手机号填写错误造成的损失由会员本人承担；",
                    "查收激活码：<span style='color:#BA274B'>兑换成功后，您预留的手机号将收到一条包含“激活码”的短信，请妥善保存</span>;",
                    "里程兑换权益不提供报销凭证，兑换成功不可退/换、转售、兑现、找零或拆分使用；",
                    "如需帮助，请拨打服务热线：4000-360-195。"
                ]
            }
        ],
        style: {
            "--theme-color": "#C3D6D4",
            "--theme-copyright-color": "#000000",
            "--theme-text-color": "#64958F",
            // "--theme-toolbar-card-color": "#D43030",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#2C5FC6",
            "--btn-color": "#477FEB"
        }
    },
    "hkl-scal": {
        name: "豪客来牛排",
        title: "川航金熊猫里程兑换豪客来牛排",
        banner: "https://images.jifen360.com/hkl/banner.png",
        login: 'scal',
        logo: "",
        coupon: require("@/assets/images/hbwl/coupon.png"),
        auto_coupon: true,
        type: "hkl",
        storeLst: require("@/utils/module/hkl.json"),
        storeName: "金熊猫会员可用门店列表",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/hbwl/order-bg.png"),
        headerImg: require("@/assets/images/meland/title1.png"),
        desc: [
            {
                title: "",
                content: [
                    "里程兑换商品不提供报销凭证，一经兑换不可退换、转售、兑现、找零、拆分使用，可转赠给他人使用；",
                    "本代金券/产品券兑换成功后，系统将自动发放到兑换时填写的手机号，<span style='color: #D43030'>请确保手机号填写正确</span>，因手机号码填写错误造成的损失由会员本人承担；",
                    "温馨提示：部分单品为3选1、2选1等可选产品，具体请查看产品介绍，到店点单时告知门店工作人员，如需帮助，请拨打客服热线：4000-360-195。"
                ]
            },
            {
                title: "使用说明：",
                content: [
                    "适用门店:适用于豪客来牛排线下门店消费使用，门店地址及联系电话请<a href='./store' style='color:#D43030;'>点击查看</a>；",
                    "有效期：自兑换成功之日起<span style='color: #D43030'>30天内有效</span>，请在有效期内使用，过期自动作废。不可补发且里程不可退；",
                    "使用规则:本代金券/产品券为一次性使用券，代金券为无门槛使用(仅限堂食)，可叠加多张同时使用，不找零不折现，不与店内其他优惠同享；",
                    "使用方式：<p>(1)<span style='color: #D43030'>微信扫码/识别短信内链接的二维码</span>，未注册“豪客来牛排”将自动跳转注册页面，请完成注册后，重新识别二维码领取；</p><p>(2)领取至“豪客来牛排”小程序个人账户后，到店消费，出示“豪客来牛排-买单会员码”即可使用；</p>",
                    "如部分菜品因时令或其他不可抗因素导致无法提供，商家会用等价菜品替换，具体事宜请与商家协商；",
                    "本平台仅是提供会员与商户之间的兑换服务平台，如遇商品质量问题，请及时与商户联系。"
                ]
            }
        ],
        style: {
            "--theme-color": "#F2F2F2",
            "--theme-copyright-color": "#000000",
            "--theme-text-color": "#1D3A44",
            // "--theme-toolbar-card-color": "#D43030",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#D43030",
            "--btn-color": "#D43030"
        }
    },
    "hkl-xmair": {
        name: "豪客来牛排",
        miniLogo: "https://images.jifen360.com/hkl/logo.png",
        title: "白鹭积分兑换豪客来牛排",
        banner: "https://images.jifen360.com/hkl/banner-xm.png",
        login: 'xm_air',
        logo: "https://images.jifen360.com/hkl/logo.png",
        coupon: require("@/assets/images/hbwl/coupon.png"),
        auto_coupon: true,
        type: "hkl",
        storeLst: require("@/utils/module/hkl.json"),
        storeName: "白鹭会员可用门店列表",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/hbwl/order-bg.png"),
        headerImg: require("@/assets/images/xm_title.png"),
        // discount: 0.95,
        // discount_end_date: "2024-06-04 23:59:59",
        desc: [
            {
                title: "",
                content: [
                    "积分兑换商品不提供报销凭证，一经兑换不可退换、转售、兑现、找零、拆分使用，可转赠给他人使用；",
                    "本代金券/产品券兑换成功后，系统将自动发放到兑换时填写的手机号，<span style='color: #008CD6'>请确保手机号填写正确</span>，因手机号码填写错误造成的损失由会员本人承担；",
                    "温馨提示：部分单品为3选1、2选1等可选产品，具体请查看产品介绍，到店点单时告知门店工作人员，如需帮助，请拨打客服热线：4000-360-195。"
                ]
            },
            {
                title: "使用说明：",
                content: [
                    "适用门店:适用于豪客来牛排线下门店消费使用，门店地址及联系电话请<a href='./store' style='color:#008CD6;'>点击查看</a>；",
                    "有效期：自兑换成功之日起<span style='color: #008CD6'>30天内有效</span>，请在有效期内使用，过期自动作废。不可补发且里程不可退；",
                    "使用规则:本代金券/产品券为一次性使用券，代金券为无门槛使用(仅限堂食)，可叠加多张同时使用，不找零不折现，不与店内其他优惠同享；",
                    "使用方式：<p>(1)<span style='color: #008CD6'>微信扫码/识别短信内链接的二维码</span>，未注册“豪客来牛排”将自动跳转注册页面，请完成注册后，重新识别二维码领取；</p><p>(2)领取至“豪客来牛排”小程序个人账户后，到店消费，出示“豪客来牛排-买单会员码”即可使用；</p>",
                    "如部分菜品因时令或其他不可抗因素导致无法提供，商家会用等价菜品替换，具体事宜请与商家协商；",
                    "本平台仅是提供会员与商户之间的兑换服务平台，如遇商品质量问题，请及时与商户联系。"
                ]
            }
        ],
        style: {
            "--theme-color": "#F2F2F2",
            "--theme-copyright-color": "#000000",
            "--theme-text-color": "#008CD6",
            // "--theme-toolbar-card-color": "#D43030",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#008CD6",
            "--btn-color": "#008CD6"
        }
    },
    "lsq-xmair": {
        name: "洛杉奇通用代金券",
        miniLogo: "",
        title: "白鹭积分兑换洛杉奇通用代金券",
        banner: "https://images.jifen360.com/lsq/banner.png",
        login: 'xm_air',
        logo: "",
        coupon: require("@/assets/images/lsq/coupon.png"),
        product_i: require("@/assets/images/lsq/coupon-ints.png"),
        auto_coupon: true,
        type: "lsq",
        storeName: "白鹭会员可用门店列表",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/lsq/order-bg.png"),
        headerImg: "https://images.jifen360.com/lsq/tools.png",
        desc: [
            {
                title: "",
                content: [
                    "积分兑换本代金券不提供报销凭证，一经兑换，不可退换、转售、兑现、找零、拆分使用；",
                    "本代金券有效期<span style='color: #008CD6'>90天</span>，请在有效期内使用，过期作废不再补发；",
                    "换成功后，预留手机将收到含代金券券码短信，<span style='color: #008CD6'>请确保手机号填写正确</span>，因手机号码填写错误造成的损失由会员本人承担；",
                    "本券为一次性使用，无消费门槛限制，可叠加多张使用，可多次兑换，除会员本人外也可供他人使用。"
                ]
            },
            {
                title: "使用方法：",
                content: [
                    "到店使用：点击短信内链接，门店工作人员核销成功后即可使用。代金券抵扣后，超出部分，请以其他方式支付；",
                    "本券适用石家庄地区“洛杉奇”、“金凤扒鸡”、“金凤鲜食城”门店，可用门店请点击<a style='color: #008CD6' href='https://platform.jifen360.com/qjf_store/?type=coupon&business=lsq'>查看门店列表</a>；",
                    "本平台仅是提供会员与商户之间的兑换服务平台，如遇购买商品质量问题，请及时与商户联系；",
                    "如需帮助，请拨打客服热线：4000-360-195。",
                ]
            }
        ],
        style: {
            "--theme-color": "#EBD7D5",
            "--theme-copyright-color": "#000000",
            "--theme-text-color": "#008CD6",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#008CD6",
            "--btn-color": "#008CD6"
        }
    },
    "lsq-scal": {
        name: "洛杉奇通用代金券",
        miniLogo: "",
        title: "川航金熊猫里程兑换洛杉奇通用代金券",
        banner: "https://images.jifen360.com/lsq/banner-scal.png",
        login: 'scal',
        logo: "",
        coupon: require("@/assets/images/lsq/coupon-scal.png"),
        product_i: require("@/assets/images/lsq/coupon-ints.png"),
        auto_coupon: true,
        type: "lsq",
        storeName: "",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/lsq/order-bg.png"),
        headerImg: "https://images.jifen360.com/lsq/tools-scal.png",
        desc: [
            {
                title: "",
                content: [
                    "里程兑换本代金券不提供报销凭证，一经兑换，不可退换、转售、兑现、找零、拆分使用；",
                    "本代金券有效期<span style='color: #DE4A43'>90天</span>，请在有效期内使用，过期作废不再补发；",
                    "换成功后，预留手机将收到含代金券券码短信，<span style='color: #DE4A43'>请确保手机号填写正确</span>，因手机号码填写错误造成的损失由会员本人承担；",
                    "本券为一次性使用，无消费门槛限制，可叠加多张使用，可多次兑换，除会员本人外也可供他人使用。"
                ]
            },
            {
                title: "使用方法：",
                content: [
                    "到店使用：点击短信内链接，门店工作人员核销成功后即可使用。代金券抵扣后，超出部分，请以其他方式支付；",
                    "本券适用石家庄地区“洛杉奇”、“金凤扒鸡”、“金凤鲜食城”门店，可用门店请点击<a style='color: #DE4A43' href='https://platform.jifen360.com/qjf_store/?type=coupon&business=lsq'>查看门店列表</a>；",
                    "本平台仅是提供会员与商户之间的兑换服务平台，如遇购买商品质量问题，请及时与商户联系；",
                    "如需帮助，请拨打客服热线：4000-360-195。",
                ]
            }
        ],
        style: {
            "--theme-color": "#EBD7D5",
            "--theme-copyright-color": "#000000",
            "--theme-text-color": "#DE4A43",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#D64D47",
            "--btn-color": "#D64D47"
        }
    },
    "pyf-xmair": {
        name: "便宜坊生活超市",
        miniLogo: "",
        title: "白鹭积分兑换便宜坊生活超市实体购物卡",
        banner: "https://images.jifen360.com/pyf/banner.png",
        login: 'xm_air',
        logo: "",
        coupon: require("@/assets/images/lsq/coupon-scal.png"),
        product_i: require("@/assets/images/pyf/coupon-pyf.png"),
        auto_coupon: true,
        type: "pyf",
        storeLst: require("@/utils/module/pyf.json"),
        storeName: "便宜坊门店列表",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/lsq/order-bg.png"),
        headerImg: "https://images.jifen360.com/lsq/tools-scal.png",
        desc: [
            {
                title: "",
                content: [
                    "积分兑换后<span style='color: #428DD0'>需到指定门店换取实体购物卡</span>，请在<span style='color: #428DD0'>90天</span>内换取，过期作废，不退不补；",
                    "兑换成功后不退不换、不找零、不兑换现金；",
                    "积分兑换不提供凭证；",
                    "如需帮忙请联系人工客服：4000-360-195。"
                ]
            },
            {
                title: "使用须知：",
                content: [
                    "实体购物卡换取地点：<p>①鹿城店：兴华路与市府街交叉口南行188米，鹿城商业广场负一层\n" +
                    "联系电话：0311-83285998</p><p>②雷锋店：教育路与育红街交叉口东南角九方盛达小区负一层\n" +
                    "联系电话：0311-83285603</p>",
                    "实体购物卡仅限“便宜坊生活超市”购物使用，全场通用，无门槛限制，可用门店请查看<a href='./store' style='color: #428DD0'>门店列表</a>；",
                    "实体购物卡为储值卡，消费次数无限制，消费金额超卡内余额时，请以其他方式支付；",
                    "其他相关要求请以门店购物卡消费规则为准。",
                ]
            }
        ],
        style: {
            "--theme-color": "#EEDED5",
            "--theme-copyright-color": "#000000",
            "--theme-text-color": "#3C82CC",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#428DD0",
            "--btn-color": "#428DD0"
        }
    },
    // "tm-xmair": {
    //     name: "天猫超市代金券",
    //     miniLogo: "",
    //     title: "白鹭积分兑换天猫超市代金券",
    //     banner: "https://images.jifen360.com/tm_mark/banner.png",
    //     login: 'xm_air',
    //     logo: "https://images.jifen360.com/tm_mark/logo.png",
    //     coupon: require("@/assets/images/lsq/coupon-scal.png"),
    //     product_i: require("@/assets/images/lsq/coupon-ints.png"),
    //     auto_coupon: true,
    //     product_type: 'third',
    //     type: "jlx",
    //     child: "tm",
    //     storeName: "",
    //     success: require("@/assets/images/jingdian/success.png"),
    //     orderBg: require("@/assets/images/lsq/order-bg.png"),
    //     headerImg: "https://images.jifen360.com/lsq/tools-scal.png",
    //     desc: [
    //         {
    //             title: "",
    //             content: [
    //                 "里程兑换本代金券不提供报销凭证，一经兑换，不可退换、转售、兑现、找零、拆分使用；",
    //                 "本代金券有效期<span style='color: #DE4A43'>90天</span>，请在有效期内使用，过期作废不再补发；",
    //                 "换成功后，预留手机将收到含代金券券码短信，<span style='color: #DE4A43'>请确保手机号填写正确</span>，因手机号码填写错误造成的损失由会员本人承担；",
    //                 "本券为一次性使用，无消费门槛限制，可叠加多张使用，可多次兑换，除会员本人外也可供他人使用。"
    //             ]
    //         },
    //         {
    //             title: "使用方法：",
    //             content: [
    //                 "到店使用：点击短信内链接，门店工作人员核销成功后即可使用。代金券抵扣后，超出部分，请以其他方式支付；",
    //                 "本券适用石家庄地区“洛杉奇”、“金凤扒鸡”、“金凤鲜食城”门店，可用门店请点击<a style='color: #DE4A43' href='https://pay.jifen360.com/third/scal-app/morestore.html?type=coupon&cid=127'>查看门店列表</a>；",
    //                 "本平台仅是提供会员与商户之间的兑换服务平台，如遇购买商品质量问题，请及时与商户联系；",
    //                 "如需帮助，请拨打客服热线：4000-360-195。",
    //             ]
    //         }
    //     ],
    //     style: {
    //         "--theme-color": "#E4EFD9",
    //         "--theme-copyright-color": "#000000",
    //         "--theme-text-color": "#428DD0",
    //         "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
    //         "--success-border-color": "#D64D47",
    //         "--btn-color": "#D64D47"
    //     }
    // },
    "hll-scal": {
        name: "好利来蛋糕卡",
        miniLogo: "",
        title: "金熊猫里程兑换好利来蛋糕卡",
        banner: "https://images.jifen360.com/haolilai/banner.png",
        login: 'scal',
        logo: "",
        coupon: "https://images.jifen360.com/haolilai/header.png",
        product_i: "https://images.jifen360.com/haolilai/product.png",
        auto_coupon: true,
        product_type: 'coupon',
        type: "haoll",
        // child: "tm",
        storeName: "",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/lsq/order-bg.png"),
        headerImg: "https://images.jifen360.com/lsq/tools-scal.png",
        desc: [
            {
                title: "",
                content: [
                    "里程兑换蛋糕卡不提供报销凭证，一经兑换，不可退换、转售、兑现、找零、拆分使用，可给他人兑换使用；",
                    "本蛋糕卡仅限选购好利来门店产品，不与其他优惠活动同时使用；",
                    "本产品兑换成功后，蛋糕卡卡号+卡密将自动发放至兑换时填写的手机号，<span style='color: #DE4A43'>请确保手机号填写正确</span>，因充值账户填写错误造成的损失由会员本人承担；",
                    "如遇蛋糕卡不能正常兑换或使用，请拨打服务热线：4000-360-195。"
                ]
            },
            {
                title: "使用说明：",
                content: [
                    "本产品有效期为自绑定成功之日起<span style='color: #DE4A43'>2年</span>有效，请在有效期内使用；",
                    "绑定流程：兑换成功后请于<span style='color: #DE4A43'>60天内完成绑定</span>，短信里复制卡号+卡密后，关注并打开“好利来”公众号，点击菜单栏“服务”-“0开头卡转电子卡”-“卡包”-“绑定新实体卡”粘贴卡号+卡密，点击“绑定”；",
                    "使用流程：打开“好利来”公众号，点击菜单栏“服务”-0开头卡转电子卡”-点击右上角“付款码”，系统将自动抵扣蛋糕卡内余额；",
                    "卡号、卡密请妥善保管，丢失无法找回；",
                    "本平台仅是提供会员与商户之间的服务平台，如遇商品质量问题，请及时与商户联系。",
                ]
            }
        ],
        style: {
            "--theme-color": "#F0E4E5",
            "--theme-copyright-color": "#000000",
            "--theme-text-color": "#D64D47",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#D64D47",
            "--btn-color": "#D64D47"
        }
    },
    "beiguo-xmair": {
        name: "北国超市代金券",
        miniLogo: "",
        title: "白鹭积分兑换北国超市代金券",
        banner: "https://images.jifen360.com/beiguo/banner.png",
        login: 'xm_air',
        logo: "",
        coupon: "https://images.jifen360.com/haolilai/header.png",
        product_i: require('@/assets/images/beiguo/mini-coupon.png'),
        auto_coupon: true,
        product_type: 'coupon',
        type: "beiguo",
        // child: "tm",
        storeName: "北国超市门店列表",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/lsq/order-bg.png"),
        headerImg: "https://images.jifen360.com/lsq/tools-scal.png",
        storeLst: require('@/utils/module/beiguo.json'),
        desc: [
            {
                title: "",
                content: [
                    "里程兑换本代金券不提供报销凭证，一经兑换，不可退换、转售、兑现、找零、拆分使用；",
                    "本蛋糕卡仅限选购好利来门店产品，不与其他优惠活动同时使用；",
                    "本蛋糕卡兑换后自动发放到兑换时填写的手机号，<span style='color: #DE4A43'>请确保手机号填写正确</span>，因充值账户填写错误造成的损失由会员本人承担",
                    "如遇蛋糕卡不能正常兑换或使用，请拨打服务热线：4000-360-195。"
                ]
            },
            {
                title: "使用说明：",
                content: [
                    "请收到蛋糕卡后<span style='color: #DE4A43'>90天</span>内激活绑定，绑定成功后<span style='color: #DE4A43'>2年</span>有效，请在有效期内使用；",
                    "绑定流程：兑换成功后，在短信里复制卡号+卡密后，关注并打开“好利来”公众号，点击公号菜单栏“服务”-“0开头卡转电子卡”-“卡包”-“绑定新实体卡”粘贴卡号+卡密，点击“绑定”；",
                    "使用流程：打开“好利来”公众号，点击菜单栏“服务”-0开头卡转电子卡”-点击右上角“付款码”，系统将自动抵扣蛋糕卡里余额；",
                    "卡号、卡密请妥善保管，丢失无法找回；",
                    "本平台仅是提供会员与商户之间的服务平台，如遇商品质量问题，请及时与商户联系。",
                ]
            }
        ],
        style: {
            "--theme-color": "#F0E4E5",
            "--theme-copyright-color": "#000000",
            "--theme-text-color": "#3E87CE",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#3E87CE",
            "--btn-color": "#3E87CE"
        }
    },
    "atl-scal": {
        name: "奥特乐代金券",
        miniLogo: "",
        title: "川航里程兑换奥特乐代金券",
        banner: "https://images.jifen360.com/atl/banner.png",
        login: 'scal',
        logo: "",
        coupon: "https://images.jifen360.com/haolilai/header.png",
        product_i: require('@/assets/images/beiguo/mini-coupon.png'),
        auto_coupon: true,
        product_type: 'coupon',
        type: "atl",
        // child: "tm",
        storeName: "北国超市门店列表",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/atl/order-bg.png"),
        // headerImg: "https://images.jifen360.com/lsq/tools-scal.png",
        storeLst: require('@/utils/module/beiguo.json'),
        desc: [

        ],
        style: {
            "--theme-color": "#ECE9F5",
            "--theme-copyright-color": "#8875B5",
            "--theme-text-color": "#DE4A43",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#7763AA",
            "--btn-color": "#7763AA"
        }
    },
    "hibake-scal": {
        name: "hi bake",
        miniLogo: "",
        title: "川航里程兑换Hi bake产品券",
        banner: "https://images.jifen360.com/hibake/banner.png",
        login: 'scal',
        logo: "",
        coupon: "https://images.jifen360.com/haolilai/header.png",
        product_i: require('@/assets/images/beiguo/mini-coupon.png'),
        auto_coupon: true,
        product_type: 'coupon',
        type: "hibake",
        // child: "tm",
        // storeName: "北国超市门店列表",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: require("@/assets/images/hibake/order-bg.png"),
        // headerImg: "https://images.jifen360.com/lsq/tools-scal.png",
        storeLst: require('@/utils/module/beiguo.json'),
        desc: [

        ],
        style: {
            "--theme-color": "#F2E0C9",
            "--theme-copyright-color": "#997547",
            "--theme-text-color": "#DE4A43",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#C8B29F",
            "--btn-color": "#C8B29F"
        }
    },
    "wjg-scal": {
        name: "外交官",
        miniLogo: "",
        title: "川航里程兑换外交官代金券",
        banner: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/banner-sc.png",
        login: 'scal',
        logo: "",
        coupon: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/title-sc.png",
        // product_i: require('@/assets/images/beiguo/mini-coupon.png'),
        auto_coupon: true,
        product_type: 'coupon',
        type: "waijiaoguan",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/order-bg.png",
        style: {
            "--theme-color": "#D8E6E8",
            "--theme-copyright-color": "#000",
            "--theme-text-color": "#49B0BD",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#56B6C2",
            "--btn-color": "#56B6C2",
            // "--coupon-image"
        }
    },
    "wjg-xmair": {
        name: "外交官",
        miniLogo: "",
        title: "白鹭积分兑换外交官代金券",
        banner: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/banner-xm.png",
        login: 'xm_air',
        logo: "",
        coupon: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/title-xm.png",
        // product_i: require('@/assets/images/beiguo/mini-coupon.png'),
        auto_coupon: true,
        product_type: 'coupon',
        type: "waijiaoguan",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/order-bg.png",
        style: {
            "--theme-color": "#D8E6E8",
            "--theme-copyright-color": "#000",
            "--theme-text-color": "#49B0BD",
            "--theme-active-cat-btn": "linear-gradient(120.49deg, rgb(165, 184, 208) 0%, rgb(255, 255, 255) 100%)",
            "--success-border-color": "#56B6C2",
            "--btn-color": "#56B6C2",
            // "--coupon-image"
        }
    },
    "yuanzu": {
        name: "元祖",
        miniLogo: "",
        title: "川航里程兑换元祖礼品卡",
        banner: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/yuanzu/banner.png",
        login: 'scal',
        logo: "",
        coupon: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/title-xm.png",
        // product_i: require('@/assets/images/beiguo/mini-coupon.png'),
        auto_coupon: true,
        product_type: 'coupon',
        type: "lanting-yuanzu",
        success: require("@/assets/images/jingdian/success.png"),
        orderBg: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/yuanzu/order-bg.png",
        style: {
            "--theme-color": "#EFEFEF",
            "--theme-copyright-color": "#000",
            "--theme-text-color": "#E60012",
            "--btn-color": "linear-gradient(90deg, #B562FF 0%, #8345BA 100%)",
            "--price-text": "#8345BA"
        }
    }
}
